import React from 'react'

const AddDestDialogContext = React.createContext()

export default AddDestDialogContext
